import { Form, useRouteLoaderData } from '@remix-run/react'
import { useEffect, useState } from 'react'
import rewardseatsbookingimg from '~/images/reward-seats-reserve-quickly-modal.png'
import type { loader } from '~/routes/report/v2/layout'

export default function PopupDialog() {
  const data = useRouteLoaderData<typeof loader>('routes/report/v2/layout')
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Show the popup after 5 seconds
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 2000)

    // Cleanup the timer when the component unmounts
    return () => clearTimeout(timer)
  }, [])

  // Don't show the popup if the user has already acknowledged it
  if (!isVisible || data?.hasAcknowledged) return null

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 md:-top-40 top-0">
      <div className="bg-white p-4 rounded-xl shadow-lg text-center max-w-md">
        <img
          src={rewardseatsbookingimg}
          className="my-4 mx-auto"
          alt="Rewards Seats usually get booked out quickly"
        />
        <div className="my-6">
          <h2 className="text-2xl font-bold my-4">
            Reward Seats usually get booked out quickly
          </h2>
          <p className="text-center text-lg my-4">
            Please follow our instructions promptly and proceed to redeem the
            seats we have found for you.
          </p>
        </div>

        {/* Form to acknowledge the popup */}
        <Form method="post" onSubmit={() => setIsVisible(false)}>
          <button
            type="submit"
            className="bg-primary-700 text-white mt-4 mb-2 mx-auto rounded-md hover:bg-themecolour-secondary font-bold text-xs py-3 w-5/6 flex items-center justify-center gap-1"
          >
            I understand
          </button>
        </Form>
      </div>
    </div>
  )
}
